function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFolderToolsOpen = function SvgFolderToolsOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4142,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m19 20h-15c-1.11 0-2-.9-2-2v-12c0-1.11.89-2 2-2h6l2 2h7c1.097 0 2 .903 2 2h-17v10l2.14-8h17.07l-2.28 8.5c-.23.87-1.01 1.5-1.93 1.5z",
    fill: "#e57373",
    style: {
      fill: "#1e88e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.648 14.537-7.2169 7.2105-.89492-.89492l7.2105-7.2169.90131.90131m2.8637-1.8474.37714-.37714-.50499-.50499.40911-.40911-.9077-.9077-.40911.40911-.50499-.50499-.37714.37714c-1.1123-.9077-2.3651-1.6364-3.7075-2.1478l-.53056 1.1442c1.1186.58809 2.1478 1.2976 3.1066 2.135l-.31961.31961 1.9177 1.9177.31961-.31961c.83739.95884 1.5469 1.988 2.135 3.1066l1.1442-.53056c-.51138-1.3424-1.2401-2.5953-2.1478-3.7075z",
    style: {
      fill: "#bbdefb",
      strokeWidth: 0.63923
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolderToolsOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder-tools-open.4034642c.svg";
export { ForwardRef as ReactComponent };